const summary_cards = [
  { label: 'Continuity plans', value: '5', note: 'Documented', accent: 'dark' },
  { label: 'Tested & current', value: '3', note: 'Evidence on file', accent: 'green' },
  { label: 'Review due', value: '1', note: 'Plan test pending', accent: 'amber' },
  { label: 'Test overdue', value: '1', note: 'Escalate', accent: 'red' }
];

const filters = [
  { label: 'All 5', active: true },
  { label: 'Plans 4', active: false },
  { label: 'Recovery tests 1', active: false }
];

const rows = [
  { ref: 'BC-01', plan: 'IT disaster recovery plan', process: 'Core systems', rto: '4 hours', rpo: '1 hour', last_test: 'Overdue', status: { label: 'Test overdue', class: 'bg-danger-subtle text-danger-emphasis' } },
  { ref: 'BC-02', plan: 'Head office continuity plan', process: 'Operations', rto: '24 hours', rpo: '4 hours', last_test: '12 Mar 2026', status: { label: 'Tested', class: 'bg-success-subtle text-success-emphasis' } },
  { ref: 'BC-03', plan: 'Payroll continuity', process: 'Payroll', rto: '48 hours', rpo: '24 hours', last_test: '02 Feb 2026', status: { label: 'Tested', class: 'bg-success-subtle text-success-emphasis' } },
  { ref: 'BC-04', plan: 'Critical supplier failover - cloud', process: 'Hosting', rto: '8 hours', rpo: '1 hour', last_test: 'Due', status: { label: 'Review due', class: 'bg-warning-subtle text-warning-emphasis' } },
  { ref: 'BC-05', plan: 'Crisis communication plan', process: 'Communications', rto: '2 hours', rpo: '—', last_test: '20 Apr 2026', status: { label: 'Tested', class: 'bg-success-subtle text-success-emphasis' } }
];

export default {
  name: 'ComplyonBusinessContinuity',
  data: () => ({
    summary_cards,
    filters,
    rows
  })
};
